// extracted by mini-css-extract-plugin
module.exports = {"page":"OrderList_page__1v0mg","mainTable":"OrderList_mainTable__3vFCl","subBtnStyle":"OrderList_subBtnStyle__2AATN","inputStyle":"OrderList_inputStyle__2b2zy"};